module.exports = __webpack_public_path__ + "img/drag.f177943d.svg";